import type { PostApiV1SelectionsSelectionIdApplicantResume200ResultSex } from "@/api/recrutaAI/generated/aISaaSAPI.schemas";

export const SEX_PHRASE = {
	male: "男性",
	female: "女性",
} as const satisfies Record<
	Exclude<PostApiV1SelectionsSelectionIdApplicantResume200ResultSex, null>,
	string
>;
